module.exports = __webpack_public_path__ + "static/media/luberly_1.6f070ca7.png";